<template>
  <div class="links-data-table-component">
    <link-statistics v-model="dialogLinkStatistics" :link="statisticsLink"></link-statistics>
    <custom-url-edit-dlg
        v-model="dialogEditShortUrl"
        :link="editedItem"
        @cancel="onCancelEditShortUrl"
        @save="onSaveEditShortUrl"
    >

    </custom-url-edit-dlg>
    <v-dialog v-model="dialogEditTargetUrl">
      <v-card>
        <v-container>
          <v-text-field autofocus v-model="editedItem.targetUrl" @keyup="onTargetUrlEditKeyUp"></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditComment">
      <v-card>
        <v-container>
          <v-text-field autofocus v-model="editedItem.comment" @keyup="onCommentEditKeyUp"></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="links"
      sort-by="createdAt"
      :sort-desc=true
      class="elevation-1"
      :loading="loading"
      :server-items-length="linksCount"
      :options.sync="linksDTOptions"
      @update:options="queryLinks"
    >
    <template v-slot:top>
      <v-toolbar
          flat
      >
        <v-toolbar-title>Links</v-toolbar-title>
        <v-divider
            class="mx-4"
            inset
            vertical
        ></v-divider>
        <v-tooltip
            bottom
        >
          <template v-slot:activator="{on, attrs}">
            <v-icon
                v-on="on"
                v-bind="attrs"
                @click="queryLinks"
            >
              Neuladen
              mdi-reload
            </v-icon>
          </template>
          <span>Neuladen</span>
        </v-tooltip>
        <v-divider
            class="mx-4"
            inset
            vertical
        ></v-divider>
        <v-text-field
            v-model="linksSearch"
            label="Suche"
            @keyup="onKeyUpSearch"
        ></v-text-field>
        <v-spacer></v-spacer>

<!--        <LinkEditDlg-->
<!--            ref="linkEditDlg"-->
<!--            @save="save()"-->
<!--        >-->
<!--          <template v-slot:activator>-->
<!--            <v-btn-->
<!--                color="primary"-->
<!--                dark-->
<!--                class="mb-2"-->
<!--                @click="newItem()"-->
<!--            >-->
<!--            Neuer Link-->
<!--            </v-btn>-->
<!--          </template>-->
<!--        </LinkEditDlg>-->
        <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="newItem()"
        >
          Neuer Link
        </v-btn>
        <v-dialog v-model="dialogDelete" max-width="540px">
          <v-card>
            <v-card-title class="headline">Wollen Sie diesen Eintrag wirklich löschen?</v-card-title>
            <v-card-text>
              <v-alert v-show="error"
                       color="red"
                       type="error"
              >{{error}}</v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Abbrechen</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.customUrlId="{item}">
      <a :href="formatLink(item.customUrlId)">{{formatLink(item.customUrlId)}}</a>
      &nbsp;
      <v-icon
          small
          @click="onEditShortUrl(item)"
      >
        bearbeiten
        mdi-pencil
      </v-icon>
      &nbsp;
      <v-tooltip right>
        <template v-slot:activator="{on, attrs}">
          <v-icon
              small
              v-on="on"
              v-bind="attrs"
              @click="onCopyToClipboard(item)"
          >
            in die Ziwschenablage kopieren
            mdi-content-copy
          </v-icon>
        </template>
        <span>in die Ziwschenablage kopieren</span>
      </v-tooltip>
    </template>
    <template v-slot:item.targetUrl="{item}">
      <a :href="item.targetUrl"><div class="d-inline-block" v-html="highlightSearch(item.targetUrl)"></div></a>&nbsp;
          <v-icon
            small
            class="mr-2"
            @click="onEditTargetUrl(item)"
          >
            bearbeiten
            mdi-pencil
          </v-icon>
    </template>
      <template v-slot:item.comment="{item}">
        <div class="d-inline-block" v-html="highlightSearch(item.comment)"></div>
        <v-icon
            small
            class="mr-2"
            @click="onEditComment(item)"
        >
          bearbeiten
          mdi-pencil
        </v-icon>
      </template>
    <template v-slot:item.createdAt="{item}">
      {{item.createdAt|formatDateTime}}
    </template>
      <template v-slot:item.numCalls="{item}">
        {{item.numCalls}}
        &nbsp;
        <v-icon
            small
            @click="onClickStatistics(item)">
          Statistik
          mdi-chart-bar

        </v-icon>
      </template>
    <template v-slot:item.actions="{ item }">
<!--      <v-icon-->
<!--          small-->
<!--          class="mr-2"-->
<!--          @click="editItem(item)"-->
<!--      >-->
<!--        bearbeiten-->
<!--        mdi-pencil-->
<!--      </v-icon>-->
      <v-icon
          small
          @click="deleteItem(item)"
      >
        löschen
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-alert
          v-show="error"
          color="red"
          type="error">
        {{error}}
      </v-alert>
      <v-btn
          color="primary"
          @click="initialize"
      >
        Neuladen
      </v-btn>
    </template>
  </v-data-table>
    <v-snackbar
        color="red"
        v-model="showErrorSnackbar"
    >{{error}}</v-snackbar>
  </div>
</template>

<style lang="css">
  span.searchHighlight {
    background-color: #b1d5fc;
  }
</style>

<script>
// import Config from '@/Config';
import persistentStorage from "@/services/PersistentStorage";
import LinkStatistics from "@/components/LinkStatistics";
import CustomUrlEditDlg from "@/components/CustomUrlEditDlg";
// import LinkEditDlg from "@/components/LinkEditDlg";

export default {
  name: "LinksDataTable",
  components: {CustomUrlEditDlg, LinkStatistics},
  data: () => ({
    error: '',
    dialogDelete: false,
    dialogEditTargetUrl: false,
    dialogEditComment: false,
    dialogLinkStatistics: false,
    dialogEditShortUrl: false,
    links: [],
    linksCount: 0,
    linksDTOptions: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['createdAt'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false
    },
    linksSearch: '',
    stdLanguageId: 0,
    languageTab: null,
    languages: [],
    editedIndex: -1,
    editedItem: {
    },
    defaultItem: {
      targetUrl: ''
    },
    statisticsLink: null,
    loading: false
  }),

  computed: {
    showErrorSnackbar: {
      set(val) {
        if(val == false) {
          this.error = '';
        }
      },
      get() {
        return this.error != ''
      }
    },
    headers: {
      get() {
        let headers = [
          {
            text: 'Short URL',
            align: 'start',
            value: 'customUrlId',
            sortable: false
          },
          {
            text: 'Ziel URL',
            align: 'start',
            value: 'targetUrl'
          },
          {
            text: 'Bemerkung',
            align: 'start',
            value: 'comment'
          },
          {
            text: 'Erstellt',
            align: 'end',
            value: 'createdAt'
          },
          {
            text: 'Aufrufe',
            align: 'end',
            value: 'numCalls',
            sortable: false
          }
        ];
        headers.push(
          {
            text: '',
            value: 'actions',
            sortable: false
          }
        );
        return headers;
      }
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Neuer Link' : 'Link bearbeiten'
    },
  },

  watch: {
    dialogDelete (val) {
      val || this.closeDelete()
    },
    dialogEditTargetUrl (val) {
      val || this.closeAndSaveEditItem();
    },
    dialogEditComment (val) {
      val || this.closeAndSaveEditItem();
    }
  },
  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.queryLinks('');
    },
    newItem() {
      persistentStorage.saveObject('links', this.defaultItem).then(
        function() {
          this.queryLinks();
        }.bind(this),
        function() {
          this.setError('Fehler beim Anlegen eines neuen Links');
        }.bind(this)
      );
    },
    editItem (item) {
      this.editedIndex = this.links.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.$refs.linkEditDlg.show = true;
      this.error = '';
    },

    deleteItem (item) {
      this.editedIndex = this.links.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.error = '';
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      persistentStorage.deleteObject('links', this.links[this.editedIndex].id)
        .then(
          function() {
            this.queryLinks();
            this.closeDelete();
          }.bind(this),
          function(error) {
            this.error = error;
          }.bind(this));
    },

    close () {
      this.error = '';
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      persistentStorage.saveObject('links', this.editedItem)
        .then(function(response) {
          this.editedItem.id = response.id;
          this.error = '';
          this.queryLinks();
        }.bind(this), function(error) {
          this.error = error;
        }.bind(this));
    },
    async queryLinks () {
      this.loading = true;
      persistentStorage.getObjectList('links', this.linksSearch?{targetUrl: '%' + this.linksSearch + '%', comment: '%' + this.linksSearch + '%'}:undefined, this.linksDTOptions.page, this.linksDTOptions.itemsPerPage, this.linksDTOptions.sortBy[0], this.linksDTOptions.sortDesc[0])
        .then(function(result) {
          this.links = result.result;
          this.linksCount = result.count;
          this.loading = false;
        }.bind(this), function(error) {
          this.links = [];
          this.error = error;
          this.loading = false;
        }.bind(this));
    },
    setError(errorMsg) {
      this.error = errorMsg;
    },
    onEditShortUrl(link) {
      this.dialogEditShortUrl = true;
      this.editedItem = Object.assign({}, link);
    },
    onCancelEditShortUrl() {
      this.editedItem = {};
      this.dialogEditShortUrl = false;
    },
    onSaveEditShortUrl() {
      this.dialogEditShortUrl = false;
      persistentStorage.saveObject('links', this.editedItem).then(
        function() {
          this.editedItem = {};
          this.queryLinks();
        }.bind(this),
        function(error) {
          this.editedItem = {};
          this.setError(error);
        }.bind(this)
      )
    },
    onEditTargetUrl(link) {
      console.log(link);
      this.dialogEditTargetUrl = true;
      this.editedItem = link;
    },
    onEditComment(link) {
      this.dialogEditComment = true;
      this.editedItem = link;
    },
    onTargetUrlEditKeyUp(evt) {
      if(evt.key=='Enter') {
        this.dialogEditTargetUrl = false;
      }
    },
    onCommentEditKeyUp(evt) {
      if(evt.key=='Enter') {
        this.dialogEditComment = false;
      }
    },
    closeAndSaveEditItem() {
      persistentStorage.saveObject('links', this.editedItem)
        .then(
          function() {
            this.queryLinks();
          }.bind(this),
          function(error) {
            console.log(error);
            this.setError(error)
          }.bind(this)
        )
    },
    onCopyToClipboard(link) {
      let formattedLink = this.formatLink(link.customUrlId);
      navigator.clipboard.writeText(formattedLink);
    },
    formatLink(urlId) {
      return 'https://b-t.one/'+urlId;
    },
    onKeyUpSearch() {
      if(this.searchChangeTimer) {
        clearTimeout(this.searchChangeTimer);
      }
      this.searchChangeTimer = setTimeout(function() {
        this.queryLinks();
      }.bind(this), 300)
    },
    onClickStatistics(link) {
      this.statisticsLink = link;
      this.dialogLinkStatistics = true;
    },
    highlightSearch(str) {
      if(str && this.linksSearch) {
        let regex = new RegExp("(" + this.linksSearch + ")", "i");
        return str.replace(regex, '<span class="searchHighlight">$1</span>');
      }
      return str;
    }

  }
}
</script>